// composables/useUserSelections.js
import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useCompaniesStore } from '@/stores/companies';
import { useEmployeesStore } from '@/stores/employees';

export function useUserSelections() {
  const companiesStore = useCompaniesStore();
  const employeesStore = useEmployeesStore();
  const { companiesList } = storeToRefs(companiesStore);
  const { employeesList } = storeToRefs(employeesStore);
  const employeesListLoading = computed(() => (
    employeesStore.employeesLoading || companiesStore.companiesLoading
  ));

  const fetchEmployees = () => employeesStore.ensureEmployees();
  const selectedCompany = ref(null);
  const selectedEmployee = ref(null);

  const filteredEmployees = computed(() => {
    if (!employeesList.value || !Array.isArray(employeesList.value)) {
      console.warn('employeesList.value is not an array:', employeesList.value);
      return [];
    }

    const excludedStatuses = ['Resigned', 'Terminated', 'Hold', 'Cancelled'];
    
    return employeesList.value.filter(employee => {
      const companyMatch = !selectedCompany.value || employee.employee_company_id === selectedCompany.value.company_id;
      const statusCheck = !excludedStatuses.includes(employee.employee_status);
      return companyMatch && statusCheck;
    });
  });

  const onCompanyClear = () => {
    selectedCompany.value = null;
    selectedEmployee.value = null;
  };

  const onEmployeeClear = () => {
    selectedEmployee.value = null;
  };

  const onCompanyChange = (event) => {
    selectedCompany.value = event.value;
    selectedEmployee.value = null;
  };

  const onEmployeeSelect = (event) => {
    const selectedValue = event.value || event.data;
    selectedEmployee.value = selectedValue;

    if (selectedValue) {
      selectedCompany.value = companiesList.value.find(
        company => company.company_id === selectedValue.employee_company_id
      ) || null;
    }
  };

  return {
    selectedCompany,
    selectedEmployee,
    employeesListLoading,
    filteredEmployees,
    companiesList,
    onEmployeeClear,
    onCompanyClear,
    onCompanyChange,
    onEmployeeSelect,
    fetchEmployees
  };
}
